import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FAQ() {
  return (
    <section data-testid="faq-section" id="faq" className="section-pad">
      <div className="container-pad mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <span className="eyebrow justify-center">
            <span className="w-8 h-px bg-teal-500" />
            Common Questions
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-navy tracking-tight mt-5 leading-[1.15]">
            Frequently asked <strong className="font-bold text-teal-600">questions.</strong>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              className="bg-white border border-gray-100 rounded-2xl px-6 hover:border-teal-200 transition"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading font-semibold text-navy hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-navy/70 leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
